import buildJson from '@/config/build.json';

const BuildVersion = () => <div className="hidden sm:block justify-start">Build: {buildJson.build}</div>;

export default BuildVersion;
